import { SegmentedController } from "@procore/core-react";
import React, { useEffect, useState } from "react";
import { getBoardsConfigurePanelValues, updateBoardsConfigurePanelLocalStorage } from ".";
import "./index.css";
import { useI18nContext } from "@procore/core-react";

interface ColumnWidthSegmentedControllerProps {
   updateColumnWidths: () => void;
}

export default function ColumnWidthSegmentedController({
   updateColumnWidths,
}: ColumnWidthSegmentedControllerProps) {
   const I18n = useI18nContext();
   const [selectedOption, setSelectedOption] = useState<string>("small");

   useEffect(() => {
      const storedOption = getBoardsConfigurePanelValues().columnWidth;
      if (storedOption) {
         setSelectedOption(storedOption);
      }
   }, []);

   const handleChange = (value: string) => {
      setSelectedOption(value);
      updateBoardsConfigurePanelLocalStorage("columnWidth", String(value));
      updateColumnWidths();
   };

   return (
      <SegmentedController className={`custom-width-segmented-controller ${selectedOption}`}>
         <SegmentedController.Segment
            onClick={() => handleChange("small")}
            selected={selectedOption === "small"}
         >
            {I18n.t("views.company.workforce_planning.boards.configure_panel.small")}
         </SegmentedController.Segment>
         <SegmentedController.Segment
            onClick={() => handleChange("medium")}
            selected={selectedOption === "medium"}
         >
            {I18n.t("views.company.workforce_planning.boards.configure_panel.medium")}
         </SegmentedController.Segment>
         <SegmentedController.Segment
            onClick={() => handleChange("large")}
            selected={selectedOption === "large"}
         >
            {I18n.t("views.company.workforce_planning.boards.configure_panel.large")}
         </SegmentedController.Segment>
      </SegmentedController>
   );
}
